"use client";

import { ApplicationVariant } from "@ea/shared_types/next/ea.enums";
import React, { createContext, useContext } from "react";

export const BrandContext = createContext<{ appVariant: ApplicationVariant } | undefined>(
  undefined,
);

export const useBrand = () => {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error("Component must be rendered under BrandProvider component");
  }
  return context;
};

export const BrandProvider = ({
  children,
  appVariant,
}: {
  children: React.ReactNode;
  appVariant?: ApplicationVariant;
}) => {
  return (
    <BrandContext.Provider value={{ appVariant: appVariant || ApplicationVariant.EA }}>
      {children}
    </BrandContext.Provider>
  );
};
